import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import Translate from 'client/components/translate';
import BrandLogo from 'client/components/brandLogo';
import Button from 'client/components/button/button';
import InputGroup from 'client/components/form/inputGroup';
import { email } from 'web-core/src/utils/validate';
import { requestReset } from 'client/actions/user';
import 'client/styles/account.scss';

const mapStateToProps = state => ({
  brandName: state.brand,
});

const propTypes = {
  requestReset: PropTypes.func.isRequired,
  brandName: PropTypes.string.isRequired,
};

export class ResetPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitted: false,
      username: {
        value: '',
        error: null,
      },
    };
  }

  validateUsername(state, username) {
    const newState = {
      username: {
        error: null,
      },
    };

    if (!username) {
      newState.username.error = { path: 'common.form.error.required' };
    } else if (!email.test(username)) {
      newState.username.error = { path: 'common.error.invalidEmail' };
    }

    return this.mergeVals(state, newState);
  }

  mergeVals = (state, newState) => _.merge({}, state, newState);

  handleSubmit = (e) => {
    e.preventDefault();

    const username = this.state.username.value;
    const validation = this.validateUsername(this.state, username);

    if (!validation.username.error) {
      return this.props
        .requestReset({ email: username })
        .then(() => this.setState({ submitted: true }));
    }

    this.setState({ ...validation });
    return false;
  };

  handleChange = (e) => {
    const { username } = this.state;
    const newVal = e.target.value;
    let newState = this.mergeVals(this.state, { username: { value: newVal } });

    if (username.error) {
      newState = this.validateUsername(newState, newVal);
    }

    this.setState(newState);
  };

  handleBlur = () => this.setState(this.validateUsername(this.state, this.state.username.value));

  renderForm() {
    const { username } = this.state;

    return (
      <div className="pad-top-2">
        <InputGroup
          id="username"
          label={{
            path: 'common.label.email',
          }}
          type="text"
          value={username.value}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          error={username.error} />
        <div className="text-center">
          <Button className="cta-button" clickHandler={this.handleSubmit}>
            <Translate path="common.account.requestReset.cta" />
          </Button>
        </div>
      </div>
    );
  }

  renderConfirmation() {
    return (
      <div className="text-center">
        <p>
          <Translate
            path="common.account.requestReset.confirmation"
            using={{ email: this.state.username.value }} />
        </p>
      </div>
    );
  }

  render() {
    return (
      <div className="account-page">
        <div className="hero flex-row">
          <div className="center-col-small flex-column">
            <BrandLogo assetBase="/assets" brandName={this.props.brandName} />
          </div>
        </div>
        <div className="center-col-small" style={{ paddingBottom: '4rem' }}>
          <div className="pad-top-2 pad-x-small-only">
            <h4>
              <Translate
                path={
                  this.state.submitted
                    ? 'common.account.requestReset.hero.success'
                    : 'common.account.requestReset.hero.initial'
                } />
            </h4>
            {this.state.submitted ? this.renderConfirmation() : this.renderForm()}
          </div>
        </div>
      </div>
    );
  }
}

ResetPage.propTypes = propTypes;

export default connect(mapStateToProps, {
  requestReset,
})(ResetPage);
